import type { ReactNode } from "react";

import { useAuth } from "../../../context/AuthProvider";
import Breadcrumb from "../../../shared/components/layout/Breadcrumb";
import PageLayout from "../../../shared/components/layout/PageLayout";
import Wrapper from "../../../shared/components/layout/Wrapper";

import AccountSidebar from "./AccountSidebar";

interface AccountLayoutProps {
    breadcrumb: { title: string; link: string }[];
    children: ReactNode;
}

const AccountLayout = ({ breadcrumb, children }: AccountLayoutProps) => {
    const { user } = useAuth();

    return (
        <PageLayout>
            <Wrapper>
                <Breadcrumb items={breadcrumb} wrapper={false} />

                <div className="w-full flex flex-1 flex-col lg:flex-row gap-x-10">
                    <div className="w-full lg:w-4/5">{children}</div>
                    {user && <AccountSidebar user={user} />}
                </div>
            </Wrapper>
        </PageLayout>
    );
};

export default AccountLayout;